import React, { useState } from "react";
import { Button } from "../ui/button"; // Import UI components
import { Card } from "../ui/card"; // Import UI components
import { Input } from "../ui/input"; // Import UI components

const UserDetails = ({ onSubmit, token }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (formData.firstName && formData.lastName) {
  //     // Navigate to the recording page with user data and token in state
  //     console.log("State being passed:", {
  //       firstName: formData.firstName,
  //       middleName: formData.middleName,
  //       lastName: formData.lastName,
  //       token: token,
  //     });
  //     navigate("/record", {
  //       replace: true,
  //       state: {
  //         firstName: formData.firstName,
  //         middleName: formData.middleName,
  //         lastName: formData.lastName,
  //         token: token,
  //       },
  //     });
  //   } else {
  //     alert("Please fill in all required fields.");
  //   }
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.firstName && formData.lastName) {
      onSubmit({ ...formData, token });
    } else {
      alert("Please fill in all required fields.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="w-full bg-gradient-to-b from-black to-[#353535] p-8">
        <h1 className="text-white text-4xl font-bold text-center">
          Consent Form
        </h1>
      </div>

      {/* Main Content - Centered Card */}
      <div className="max-w-3xl mx-auto p-6 mt-8">
        <Card className="bg-white shadow-lg rounded-xl overflow-hidden">
          {/* Steps */}
          <div className="p-6 bg-gray-50 border-b">
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 rounded-full bg-black text-white flex items-center justify-center">
                  1
                </div>
                <div>
                  <p className="text-gray-500 text-sm">Step 1</p>
                  <h2 className="text-xl font-medium">Share your full name</h2>
                </div>
              </div>
              <div className="h-px bg-gradient-to-r from-black to-gray-300"></div>
              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 rounded-full bg-gray-300 text-gray-600 flex items-center justify-center">
                  2
                </div>
                <div>
                  <p className="text-gray-500 text-sm">Step 2</p>
                  <h2 className="text-xl font-medium">Record live consent</h2>
                </div>
              </div>
            </div>
          </div>

          {/* Form Content */}
          <div className="p-6">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label className="text-gray-600 text-lg">First Name</label>
                <Input
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="mt-1 h-12 w-full bg-gray-50 border-gray-300 focus:ring-black focus:border-black rounded-lg"
                  required
                />
              </div>
              <div>
                <label className="text-gray-600 text-lg">Middle Name</label>
                <Input
                  name="middleName"
                  value={formData.middleName}
                  onChange={handleInputChange}
                  className="mt-1 h-12 w-full bg-gray-50 border-gray-300 focus:ring-black focus:border-black rounded-lg"
                />
              </div>
              <div>
                <label className="text-gray-600 text-lg">Last Name</label>
                <Input
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className="mt-1 h-12 w-full bg-gray-50 border-gray-300 focus:ring-black focus:border-black rounded-lg"
                  required
                />
              </div>
              <Button
                type="submit"
                className="w-full h-12 text-lg bg-gradient-to-b from-black to-[#353535] text-white rounded-full hover:opacity-90 transition-opacity"
              >
                Next Step
              </Button>
            </form>
          </div>
        </Card>
      </div>
    </div>
  );
};
export default UserDetails;

// </div>
// <Button
//   onClick={handleSubmit}
//   className="w-full h-12 text-lg bg-black hover:bg-gray-800 text-white rounded-full"
// >
//   Next Step
// </Button>
// </form>
// </Card>
// );
// };
